import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  globalCss: {
    'html, body': {
      margin: 0,
      padding: 0,
      fontFamily: 'Roboto, sans-serif',
      backgroundColor: 'var(--chakra-colors-bg)',
      color: 'var(--chakra-colors-fg)',
    },
    '*': {
      scrollbarWidth: 'thin',
      scrollbarColor: '#00B0CA transparent',
    },
    '*::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },
    '*::-webkit-scrollbar-thumb': {
      background: '#00B0CA',
      borderRadius: '4px',
    },
    '*::-webkit-scrollbar-track': {
      background: 'transparent',
    },
  },
  theme: {
    tokens: {
      fonts: {
        body: { value: 'Roboto, sans-serif' },
        heading: { value: 'Roboto, sans-serif' },
      },
      colors: {
        brand: {
          cyan: { value: '#00B0CA' },
          cyanLight: { value: '#33C4D8' },
          cyanDark: { value: '#008FA3' },
          cyanGlow: { value: 'rgba(0,176,202,0.15)' },
          navy: { value: '#0A1B2B' },
          navyMid: { value: '#0E2438' },
          navyLight: { value: '#132d42' },
        },
        // Light mode palette — white background as primary
        light: {
          bg: { value: '#FFFFFF' },
          surface: { value: '#FFFFFF' },
          surfaceAlt: { value: '#F7FBFD' },
          text: { value: '#0A1B2B' },
          muted: { value: '#4E6E84' },
          border: { value: '#E2EEF4' },
          accent: { value: '#00B0CA' },
        },
        // Dark mode palette
        dark: {
          bg: { value: '#060F18' },
          surface: { value: '#0A1B2B' },
          surfaceAlt: { value: '#0D2035' },
          text: { value: '#E2EFF5' },
          muted: { value: '#6090A8' },
          border: { value: '#132d42' },
          accent: { value: '#00B0CA' },
        },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          DEFAULT: {
            value: { _light: '{colors.light.bg}', _dark: '{colors.dark.bg}' },
          },
        },
        surface: {
          DEFAULT: {
            value: {
              _light: '{colors.light.surface}',
              _dark: '{colors.dark.surface}',
            },
          },
        },
        fg: {
          DEFAULT: {
            value: {
              _light: '{colors.light.text}',
              _dark: '{colors.dark.text}',
            },
          },
        },
        muted: {
          DEFAULT: {
            value: {
              _light: '{colors.light.muted}',
              _dark: '{colors.dark.muted}',
            },
          },
        },
        border: {
          DEFAULT: {
            value: {
              _light: '{colors.light.border}',
              _dark: '{colors.dark.border}',
            },
          },
        },
        accent: {
          DEFAULT: {
            value: {
              _light: '{colors.light.accent}',
              _dark: '{colors.dark.accent}',
            },
          },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
